(function(){
  'use strict';

  function isMobileProduct(){
    return !!(window.matchMedia && window.matchMedia('(max-width: 767px)').matches && document.querySelector('.main-content-detail .details-info'));
  }

  function addStyles(){
    if (document.getElementById('erectus-product-mobile-styles')) return;
    var style = document.createElement('style');
    style.id = 'erectus-product-mobile-styles';
    style.textContent = [
      '@media (max-width:767px){',
      '.main-content-detail{padding-top:4px!important;}',
      '.main-content-detail .details-thumb{margin-bottom:12px!important;}',
      '.main-content-detail .details-info{padding-top:6px!important;}',
      '.main-content-detail .details-info .product-name{font-size:22px!important;line-height:1.25!important;margin:0 0 8px!important;}',
      '.main-content-detail .details-info .star-rating{margin-bottom:8px!important;}',
      '.main-content-detail .details-info .price{margin:4px 0 10px!important;line-height:1.2!important;}',
      '.main-content-detail #js-product-price,.main-content-detail [data-js-product-price]{font-size:26px!important;font-weight:700!important;line-height:1.2!important;}',
      '.main-content-detail .free-shipping{margin:10px 0 12px!important;border-radius:8px!important;overflow:hidden!important;}',
      '.main-content-detail .free-shipping__text{min-height:42px!important;display:flex!important;align-items:center!important;justify-content:center!important;padding:7px 10px!important;text-align:center!important;font-size:13px!important;line-height:1.3!important;}',
      '.main-content-detail .inventory_qty{margin:10px 0 12px!important;}',
      '.main-content-detail .page_product_countdown{display:none!important;}',
      '.main-content-detail .product-collection__options{margin:8px 0 12px!important;}',
      '.main-content-detail .product-options .cms-option-item{margin:0 0 12px!important;}',
      '.main-content-detail .product-options .cms-option-item>label{display:block!important;margin:0 0 7px!important;font-size:13px!important;font-weight:700!important;line-height:1.3!important;}',
      '.main-content-detail .product-options__section{gap:7px!important;padding-left:0!important;padding-right:0!important;}',
      '.main-content-detail .product-options__value--text,.main-content-detail .product-options__value--large-text{display:flex!important;align-items:center!important;justify-content:center!important;min-height:44px!important;min-width:44px!important;padding:9px 12px!important;margin:0!important;border-radius:7px!important;font-size:13px!important;line-height:1.2!important;}',
      '.main-content-detail .product-options__value--square,.main-content-detail .product-options__value--circle{min-width:44px!important;min-height:44px!important;}',
      '.main-content-detail .product-options select[data-js-option-select]{width:100%!important;min-height:46px!important;padding:8px 34px 8px 11px!important;border-radius:7px!important;font-size:14px!important;}',
      '.main-content-detail .cms-product-meta{display:flex!important;align-items:stretch!important;gap:10px!important;margin:12px 0 0!important;width:100%!important;}',
      '.main-content-detail .cms-product-meta .js-quantity.quantity{flex:0 0 92px!important;width:92px!important;min-width:92px!important;margin:0!important;}',
      '.main-content-detail .cms-product-meta .group-button{flex:1 1 auto!important;width:auto!important;margin:0!important;}',
      '.main-content-detail .cms-product-meta .group-button .inner{display:block!important;width:100%!important;height:100%!important;}',
      '.main-content-detail .cms-product-meta .add-to-cart.js_add_to_cart_button{display:flex!important;align-items:center!important;justify-content:center!important;width:100%!important;min-height:52px!important;height:100%!important;margin:0!important;padding:12px 14px!important;border-radius:8px!important;font-size:15px!important;font-weight:700!important;line-height:1.2!important;text-align:center!important;}',
      '.main-content-detail .cms-product-meta .js-btn-sold-out{min-height:52px!important;border-radius:8px!important;}',
      '.main-content-detail .erectus-product-trust{display:flex!important;align-items:center!important;justify-content:center!important;min-height:38px!important;margin:8px 0 0!important;padding:8px 10px!important;border:1px solid rgba(0,0,0,.09)!important;border-radius:8px!important;background:#f7f7f7!important;font-size:12.5px!important;font-weight:600!important;line-height:1.3!important;text-align:center!important;}',
      '.main-content-detail .product_description{margin:16px 0 10px!important;font-size:14.5px!important;line-height:1.55!important;}',
      '.main-content-detail .product-collection__sku,.main-content-detail .product-collection__barcode,.main-content-detail .product-collection__type{display:none!important;}',
      '.main-content-detail .product-page-info__visitors,.main-content-detail [data-js-product-visitors]{display:none!important;}',
      '.main-content-detail .product_page_social{margin-top:14px!important;}',
      '.tab_product_page{margin-top:0!important;}',
      '.tab_product_page>section{margin-top:26px!important;padding-bottom:28px!important;}',
      '.tab_product_page #tab_product .list-nav{display:flex!important;gap:6px!important;overflow-x:auto!important;white-space:nowrap!important;padding:0 0 8px!important;margin:0 0 12px!important;-webkit-overflow-scrolling:touch;scrollbar-width:none;}',
      '.tab_product_page #tab_product .list-nav::-webkit-scrollbar{display:none!important;}',
      '.tab_product_page #tab_product .list-nav li{flex:0 0 auto!important;margin:0!important;}',
      '.tab_product_page #tab_product .list-nav li a{display:flex!important;align-items:center!important;min-height:42px!important;padding:9px 12px!important;border:1px solid #e5e5e5!important;border-radius:8px!important;font-size:13px!important;line-height:1.2!important;}',
      '.tab_product_page #tab_product .list-nav li:has(a[href="#tab_variants"]),.tab_product_page #tab_variants{display:none!important;}',
      '.tab_product_page .kp-tags-wrap{display:none!important;}',
      '.tab_product_page .tab-content{font-size:14px!important;line-height:1.55!important;}',
      '}',
      '@media (max-width:380px){',
      '.main-content-detail .cms-product-meta{gap:7px!important;}',
      '.main-content-detail .cms-product-meta .js-quantity.quantity{flex-basis:84px!important;width:84px!important;min-width:84px!important;}',
      '.main-content-detail .cms-product-meta .add-to-cart.js_add_to_cart_button{font-size:14px!important;padding-left:10px!important;padding-right:10px!important;}',
      '}'
    ].join('');
    document.head.appendChild(style);
  }

  function improveProductOrder(root){
    if (!isMobileProduct()) return;
    var scope = (root && root.querySelector && root.querySelector('.main-content-detail')) || document.querySelector('.main-content-detail');
    if (!scope) return;
    var info = scope.querySelector('.details-info');
    if (!info) return;

    var meta = info.querySelector('.cms-product-meta');
    if (!meta) return;

    var trust = info.querySelector('.erectus-product-trust');
    if (!trust) {
      trust = document.createElement('div');
      trust.className = 'erectus-product-trust';
      trust.setAttribute('role', 'note');
      trust.textContent = 'Envío discreto · Envío gratis en compras desde $699 MXN';
      meta.insertAdjacentElement('afterend', trust);
    }

    var description = info.querySelector('.product_description');
    if (description && trust.nextElementSibling !== description) {
      trust.insertAdjacentElement('afterend', description);
    }
  }

  function normalizeVariantControls(root){
    if (!isMobileProduct()) return;
    var scope = root || document;
    scope.querySelectorAll('.main-content-detail .product-options').forEach(function(options){
      if (options.querySelector('select[data-js-option-select]')) options.classList.add('type_select');
    });
  }

  function simplifyTabs(root){
    if (!isMobileProduct()) return;
    var scope = root || document;
    scope.querySelectorAll('.tab_product_page #tab_product a[href="#tab_des"]').forEach(function(a){ a.textContent = 'Descripción'; });
    scope.querySelectorAll('.tab_product_page #tab_product a[href="#tab_review"]').forEach(function(a){
      var count = (a.textContent.match(/\(\s*\d+\s*\)/) || [''])[0];
      a.textContent = count ? 'Reseñas ' + count : 'Reseñas';
    });
    scope.querySelectorAll('.tab_product_page #tab_product a[href="#tab_variants"]').forEach(function(a){
      var li = a.closest('li');
      if (li) li.style.display = 'none';
    });
    scope.querySelectorAll('.tab_product_page #tab_variants,.tab_product_page .kp-tags-wrap').forEach(function(el){
      el.style.display = 'none';
      el.setAttribute('aria-hidden', 'true');
    });
  }

  function removeArtificialUrgency(root){
    if (!isMobileProduct()) return;
    var scope = root || document;
    scope.querySelectorAll('.main-content-detail .product-page-info__visitors,.main-content-detail [data-js-product-visitors],.main-content-detail .page_product_countdown').forEach(function(el){
      el.style.display = 'none';
      el.setAttribute('aria-hidden', 'true');
    });
  }

  function run(root){
    if (!isMobileProduct()) return;
    addStyles();
    improveProductOrder(root || document);
    normalizeVariantControls(root || document);
    simplifyTabs(root || document);
    removeArtificialUrgency(root || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ run(document); });
  } else {
    run(document);
  }

  document.addEventListener('shopify:section:load', function(e){ run(e.target || document); });
})();
